const table114 = [
    {
        key: "entity_code",
        name: "法人コード",
        editable: false
    },
    {
        key: "entity_name",
        name: "法人名",
        editable: false
    },
    {
        key: "row_number",
        name: "行番号",
        editable: false
    },
    {
        key: "tax_item",
        name: "税目",
        editable: true
    },
    {
        key: "current_outstanding_amount",
        name: "期首現在未納税額",
        editable: true
    },
    {
        key: "tax_amount_occurred_current_period",
        name: "当期発生税額",
        editable: false
    },
    {
        key: "tax_payment_disposing_reserve",
        name: "充当金取崩納付",
        editable: true
    },
    {
        key: "tax_payment_from_suspense_account",
        name: "仮払経理納付",
        editable: true
    },
    {
        key: "tax_payment_processed_loss",
        name: "損金経理納付",
        editable: false
    }
];

export { table114 };
